import { createFileRoute } from '@tanstack/react-router';
import { ExtratoBoleto } from '@/pages/extrato-boleto';

export const Route = createFileRoute('/a/extrato-boleto/')({
    component: ExtratoBoleto,
});
